/**
 * @generated SignedSource<<481cbf0ee9fa77a8bd9e79d4d48bdbc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersistentWorkerPoolInput = {
  clientMutationId: string;
  poolId: string;
};
export type PersistentWorkerPoolsListDeleteMutation$variables = {
  input: DeletePersistentWorkerPoolInput;
};
export type PersistentWorkerPoolsListDeleteMutation$data = {
  readonly deletePersistentWorkerPool: {
    readonly deletedPoolId: string;
  };
};
export type PersistentWorkerPoolsListDeleteMutation = {
  response: PersistentWorkerPoolsListDeleteMutation$data;
  variables: PersistentWorkerPoolsListDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPoolId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersistentWorkerPoolsListDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePersistentWorkerPoolPayload",
        "kind": "LinkedField",
        "name": "deletePersistentWorkerPool",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersistentWorkerPoolsListDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePersistentWorkerPoolPayload",
        "kind": "LinkedField",
        "name": "deletePersistentWorkerPool",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPoolId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1018a83fac3123c64b50af5c85ff120b",
    "id": null,
    "metadata": {},
    "name": "PersistentWorkerPoolsListDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PersistentWorkerPoolsListDeleteMutation(\n  $input: DeletePersistentWorkerPoolInput!\n) {\n  deletePersistentWorkerPool(input: $input) {\n    deletedPoolId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a4c6e7ca40d9626053084b0deec970d";

export default node;
